import React, { useState, useEffect, useRef } from "react";
import Logo from "../images/ab (6).svg";
import Logo2 from "../images/ab (2).svg";
import Logo3 from "../images/ab (3).svg";
import Logo4 from "../images/ab (4).svg";
import Logo5 from "../images/ab (5).svg";
import Logo6 from "../images/ab (1).svg";
import { Link } from "react-router-dom";
import "./Services.css";

const ServiceProvider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const carouselRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const autoSlideRef = useRef(null);

  const cardData = [
    {
      id: 1,
      logo: Logo,
      title: "Personal Loan",
      text: "For life's surprises—planned or unplanned. Get quick funds without jumping through hoops.",
      button: "Apply Now",
      link: "/Individualservice",
    },
    {
      id: 2,
      logo: Logo2,
      title: "Home Loan",
      text: "Buying a home should be a dream, not a hassle. Get approved easily and move in stress-free.",
      button: "Apply Now",
      link: "/Homeloan",
    },
    {
      id: 3,
      logo: Logo3,
      title: "Car Loan",
      text: "Speed up your journey with flexible loan options for cars, bikes, and everything in between.",
      button: "Apply Now",
      link: "/Carloan",
    },
    {
      id: 4,
      logo: Logo4,
      title: "Bike Loan",
      text: "Your dream ride, minus the hassle. Easy two-wheeler loans, stress-free approvals.",
      button: "Apply Now",
      link: "/Bikeloan",
    },
    {
      id: 5,
      logo: Logo6,
      title: "Education Loan",
      text: "The best investment ? Knowledge.    Fund your education without a second  thought.",
      button: "Apply Now",
      link: "/Educationloan",
    },
    {
      id: 6,
      logo: Logo5,
      title: "Business Loan",
      text: "A great idea needs great backing. Power your growth with funds that understand your ambition.",
      button: "Apply Now",
      link: "/Businessloan",
    },
  ];

  const cardCount = cardData.length;
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    if (
      window.innerWidth >= 1200 ||
      isPaused ||
      isDragging ||
      isTransitioning
    ) {
      return;
    }

    autoSlideRef.current = setInterval(() => {
      goToNextSlide();
    }, 3000);

    return () => {
      if (autoSlideRef.current) {
        clearInterval(autoSlideRef.current);
      }
    };
  }, [activeIndex, isPaused, isDragging, isTransitioning]);

  const pauseAutoSlide = () => {
    setIsPaused(true);
    if (autoSlideRef.current) {
      clearInterval(autoSlideRef.current);
    }
  };

  const resumeAutoSlide = () => {
    setTimeout(() => {
      setIsPaused(false);
    }, 5000);
  };

  const handleTouchStart = (e) => {
    if (window.innerWidth >= 1200) return;
    pauseAutoSlide();
    setIsDragging(true);
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(null);
    setDragOffset(0);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || window.innerWidth >= 1200) return;

    const currentTouch = e.targetTouches[0].clientX;
    setTouchEnd(currentTouch);

    const diff = currentTouch - touchStart;
    setDragOffset(diff);

    if (carouselRef.current) {
      const baseTransform = getTransformValue(activeIndex);
      const dragPercent = (diff / carouselRef.current.offsetWidth) * 100;
      carouselRef.current.style.transform = `translateX(${
        baseTransform + dragPercent
      }%)`;
    }
  };

  const handleTouchEnd = () => {
    if (!isDragging || window.innerWidth >= 1200) return;

    setIsDragging(false);
    resumeAutoSlide();

    if (touchStart === null || touchEnd === null) {
      resetCarouselPosition();
      return;
    }

    const swipeDistance = touchStart - touchEnd;
    const threshold = 50;

    if (Math.abs(swipeDistance) >= threshold) {
      if (swipeDistance > 0) {
        goToNextSlide();
      } else {
        goToPrevSlide();
      }
    } else {
      resetCarouselPosition();
    }

    setTouchStart(null);
    setTouchEnd(null);
    setDragOffset(0);
  };

  const resetCarouselPosition = () => {
    if (carouselRef.current) {
      const baseTransform = getTransformValue(activeIndex);
      carouselRef.current.style.transition = "transform 0.3s ease";
      carouselRef.current.style.transform = `translateX(${baseTransform}%)`;
      setTimeout(() => {
        if (carouselRef.current) {
          carouselRef.current.style.transition = "";
        }
      }, 300);
    }
  };

  const goToNextSlide = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);

    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      if (activeIndex === cardCount - 1) {
        animateToFirstCard();
      } else {
        const newIndex = activeIndex + 1;
        animateSlide(newIndex);
      }
    } else if (isTablet) {
      const maxIndex = Math.ceil(cardCount / 2) - 1;
      if (activeIndex === maxIndex) {
        animateToFirstCard();
      } else {
        const newIndex = activeIndex + 1;
        animateSlide(newIndex);
      }
    }
  };

  const goToPrevSlide = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);

    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      if (activeIndex === 0) {
        animateToLastCard();
      } else {
        const newIndex = activeIndex - 1;
        animateSlide(newIndex);
      }
    } else if (isTablet) {
      const maxIndex = Math.ceil(cardCount / 2) - 1;
      if (activeIndex === 0) {
        animateToLastCard();
      } else {
        const newIndex = activeIndex - 1;
        animateSlide(newIndex);
      }
    }
  };

  const animateToFirstCard = () => {
    if (!carouselRef.current) return;

    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

    if (isTablet) {
      const firstCard = carouselRef.current.children[0];
      const secondCard = carouselRef.current.children[1];
      const clonedFirst = firstCard.cloneNode(true);
      const clonedSecond = secondCard.cloneNode(true);

      carouselRef.current.appendChild(clonedFirst);
      carouselRef.current.appendChild(clonedSecond);

      const extendedTransform = getTransformValue(Math.ceil(cardCount / 2));
      carouselRef.current.style.transition =
        "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      carouselRef.current.style.transform = `translateX(${extendedTransform}%)`;

      const handleTransitionEnd = () => {
        carouselRef.current.removeChild(clonedFirst);
        carouselRef.current.removeChild(clonedSecond);
        carouselRef.current.style.transition = "none";
        carouselRef.current.style.transform = `translateX(${getTransformValue(
          0
        )}%)`;

        setTimeout(() => {
          if (carouselRef.current) {
            carouselRef.current.style.transition = "";
          }
        }, 10);

        setActiveIndex(0);
        setIsTransitioning(false);
        updateIndicators(0);
        carouselRef.current.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      };

      carouselRef.current.addEventListener(
        "transitionend",
        handleTransitionEnd
      );
    } else {
      const firstCard = carouselRef.current.children[0];
      const clonedCard = firstCard.cloneNode(true);
      carouselRef.current.appendChild(clonedCard);

      const extendedTransform = getTransformValue(cardCount);
      carouselRef.current.style.transition =
        "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      carouselRef.current.style.transform = `translateX(${extendedTransform}%)`;

      const handleTransitionEnd = () => {
        carouselRef.current.removeChild(clonedCard);
        carouselRef.current.style.transition = "none";
        carouselRef.current.style.transform = `translateX(${getTransformValue(
          0
        )}%)`;

        setTimeout(() => {
          if (carouselRef.current) {
            carouselRef.current.style.transition = "";
          }
        }, 10);

        setActiveIndex(0);
        setIsTransitioning(false);
        updateIndicators(0);
        carouselRef.current.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      };

      carouselRef.current.addEventListener(
        "transitionend",
        handleTransitionEnd
      );
    }
  };

  const animateToLastCard = () => {
    if (!carouselRef.current) return;

    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

    if (isTablet) {
      const lastCard = carouselRef.current.children[cardCount - 1];
      const secondLastCard = carouselRef.current.children[cardCount - 2];
      const clonedLast = lastCard.cloneNode(true);
      const clonedSecondLast = secondLastCard.cloneNode(true);

      carouselRef.current.insertBefore(
        clonedSecondLast,
        carouselRef.current.firstChild
      );
      carouselRef.current.insertBefore(
        clonedLast,
        carouselRef.current.firstChild
      );

      carouselRef.current.style.transition = "none";
      carouselRef.current.style.transform = `translateX(${getTransformValue(
        -1
      )}%)`;

      carouselRef.current.style.transition =
        "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      carouselRef.current.style.transform = `translateX(${getTransformValue(
        0
      )}%)`;

      const handleTransitionEnd = () => {
        carouselRef.current.removeChild(clonedLast);
        carouselRef.current.removeChild(clonedSecondLast);
        carouselRef.current.style.transition = "none";

        const maxIndex = Math.ceil(cardCount / 2) - 1;
        carouselRef.current.style.transform = `translateX(${getTransformValue(
          maxIndex
        )}%)`;

        setTimeout(() => {
          if (carouselRef.current) {
            carouselRef.current.style.transition = "";
          }
        }, 10);

        setActiveIndex(maxIndex);
        setIsTransitioning(false);
        updateIndicators(maxIndex);
        carouselRef.current.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      };

      carouselRef.current.addEventListener(
        "transitionend",
        handleTransitionEnd
      );
    } else {
      const lastCard = carouselRef.current.children[cardCount - 1];
      const clonedCard = lastCard.cloneNode(true);
      carouselRef.current.insertBefore(
        clonedCard,
        carouselRef.current.firstChild
      );

      carouselRef.current.style.transition = "none";
      carouselRef.current.style.transform = `translateX(${getTransformValue(
        -1
      )}%)`;

      carouselRef.current.style.transition =
        "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      carouselRef.current.style.transform = `translateX(${getTransformValue(
        0
      )}%)`;

      const handleTransitionEnd = () => {
        carouselRef.current.removeChild(clonedCard);
        carouselRef.current.style.transition = "none";
        carouselRef.current.style.transform = `translateX(${getTransformValue(
          cardCount - 1
        )}%)`;

        setTimeout(() => {
          if (carouselRef.current) {
            carouselRef.current.style.transition = "";
          }
        }, 10);

        setActiveIndex(cardCount - 1);
        setIsTransitioning(false);
        updateIndicators(cardCount - 1);
        carouselRef.current.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      };

      carouselRef.current.addEventListener(
        "transitionend",
        handleTransitionEnd
      );
    }
  };

  const updateIndicators = (index) => {
    const indicators = document.querySelectorAll(".carousel__indicator-3");
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

    if (indicators.length) {
      indicators.forEach((dot, i) => {
        dot.classList.remove("active");
      });

      if (isTablet) {
        if (indicators[index]) {
          indicators[index].classList.add("active");
        }
      } else {
        if (indicators[index]) {
          indicators[index].classList.add("active");
        }
      }
    }
  };

  const handleIndicatorClick = (index) => {
    if (isTransitioning || index === activeIndex) return;

    pauseAutoSlide();
    resumeAutoSlide();

    const cards = document.querySelectorAll(".cols");
    const indicators = document.querySelectorAll(".carousel__indicator-3");
    const isDesktop = window.innerWidth >= 1200;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
    const isMobile = window.innerWidth < 768;
    const isTouchDevice = isMobile || isTablet;

    cards.forEach((card, idx) => {
      const cardElement = card.querySelector(".card");
      if (!cardElement) return;

      cardElement.onmouseenter = null;
      cardElement.onmouseleave = null;
      cardElement.onclick = null;
      cardElement.ontouchstart = null;

      cardElement.style.transform = "translateY(0)";
      cardElement.style.marginBottom = isTouchDevice ? "0" : "16px";
      cardElement.style.boxShadow = isTouchDevice
        ? "4px 0px 10px rgba(0, 0, 0, 0.02), -4px 0px 10px rgba(0, 0, 0, 0.02)"
        : "0px 2px 12px rgba(0, 0, 0, 0.03)";

      if (idx === index && !isTouchDevice) {
        cardElement.style.transform = "translateY(-5px)";
        cardElement.style.boxShadow = "0px 8px 30px rgba(0, 0, 0, 0.05)";
      }

      if (isDesktop) {
        cardElement.onmouseenter = () => {
          if (activeIndex !== idx) handleIndicatorClick(idx);
        };
        cardElement.onmouseleave = () => {
          if (idx !== activeIndex) {
            cardElement.style.transform = "translateY(0)";
            cardElement.style.boxShadow = "0px 2px 12px rgba(0, 0, 0, 0.03)";
          }
        };
      }

      const activateCard = () => {
        if (activeIndex !== idx) handleIndicatorClick(idx);
      };
      cardElement.onclick = activateCard;
      cardElement.ontouchstart = activateCard;
    });

    updateIndicators(index);

    if ((isMobile || isTablet) && index >= 0 && index < cardCount) {
      animateSlide(index);
      setActiveIndex(index);
    } else if (isDesktop && index >= 0 && index < cardCount) {
      setActiveIndex(index);
    }
  };

  const animateSlide = (newIndex) => {
    if (!carouselRef.current) return;

    const baseTransform = getTransformValue(newIndex);

    carouselRef.current.style.transition =
      "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
    carouselRef.current.style.transform = `translateX(${baseTransform}%)`;

    const handleTransitionEnd = () => {
      setActiveIndex(newIndex);
      setIsTransitioning(false);
      updateIndicators(newIndex);
      if (carouselRef.current) {
        carouselRef.current.style.transition = "";
        carouselRef.current.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      }
    };

    carouselRef.current.addEventListener("transitionend", handleTransitionEnd);
  };

  const getCardsPerView = () => {
    if (window.innerWidth >= 1200) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  };

  const [cardsPerView, setCardsPerView] = useState(getCardsPerView());

  useEffect(() => {
    const handleResize = () => {
      const newCardsPerView = getCardsPerView();
      setCardsPerView(newCardsPerView);

      const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
      const isMobile = window.innerWidth < 768;

      if (isTablet && activeIndex >= Math.ceil(cardCount / 2)) {
        setActiveIndex(0);
      }

      if (carouselRef.current) {
        const baseTransform = getTransformValue(activeIndex);
        carouselRef.current.style.transform = `translateX(${baseTransform}%)`;
      }

      updateIndicators(activeIndex);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [activeIndex, cardCount]);

  const getTransformValue = (index) => {
    if (window.innerWidth < 768) {
      return -(index * 100);
    } else if (window.innerWidth < 1200) {
      return -(index * 100);
    } else {
      return 0;
    }
  };

  const handleMouseEnter = () => {
    if (window.innerWidth < 1200) {
      pauseAutoSlide();
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth < 1200) {
    }
  };

  useEffect(() => {
    updateIndicators(activeIndex);
  }, [activeIndex]);

  return (
    <div
      className="sectionpart py-3 position-relative"
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, #F3F8FF 50%, rgba(255, 255, 255, 1) 100%)",
        position: "relative",
        overflow: "hidden",
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="main_box mx-auto responsive-width">
        <div className="position-relative">
          <h2
            className="text-center mb-5 mt-4 fw-semibold"
            style={{ fontSize: "32px", color: "#4B4B4B" }}
          >
            Services We Provide
          </h2>

          <div className="position-relative overflow-hidden">
            <div
              ref={carouselRef}
              className="row row_row d-flex flex-nowrap"
              style={{
                transform: `translateX(${getTransformValue(activeIndex)}%)`,
                transition: isDragging ? "none" : "",
              }}
            >
              {cardData.map((card, index) => (
                <div
                  key={card.id}
                  className="col cols px-md-3 d-flex justify-content-center"
                >
                  <div
                    className="card text-center p-0 bg-white h-55"
                    style={{
                      cursor: "pointer",
                      border: "0 !important",
                      outline: "none !important",
                      maxWidth: "28rem",
                      width: "100%",
                      backdropFilter: "blur(12px)",
                      WebkitBackdropFilter: "blur(12px)",
                      borderRadius: "12px",
                      boxShadow:
                        typeof window !== "undefined" &&
                        window.innerWidth >= 1200
                          ? activeIndex === index
                            ? "0px 8px 30px rgba(0, 0, 0, 0.05)"
                            : "0px 2px 12px rgba(0, 0, 0, 0.03)"
                          : "none",
                      transform:
                        activeIndex === index
                          ? "translateY(-5px)"
                          : "translateY(0)",
                      transition: "all 0.4s ease",
                    }}
                  >
                    <div className="d-flex justify-content-center align-items-center pt-3 pb-2">
                      <div className="icon-wrapper bg-light p-1 rounded-circle">
                        <img
                          src={card.logo}
                          className="card-img-top"
                          alt={`${card.title} icon`}
                          style={{
                            height: "50px",
                            width: "50px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </div>
                    <div className="card-body d-flex flex-column">
                      <h5
                        className="card-title mb-3 fw-semibold"
                        style={{ color: "#4B4B4B", fontWeight: "500" }}
                      >
                        {card.title}
                      </h5>
                      <p className="card-text fs-16 text-gray-616161 text-center font-inter">
                        {card.text}
                      </p>
                      <div className="mt-auto">
                        <Link to={card.link} className="text-decoration-none">
                          <button
                            className="btn btn-outline-white d-flex align-items-center justify-content-center mx-auto"
                            style={{
                              borderRadius: "50px",
                              padding: "8px 20px",
                              width: "fit-content",
                              minWidth: "140px",
                              marginTop: "10px",
                              textDecoration: "none",
                              fontFamily: "poppins",
                              fontWeight: "700",
                              color: "#0F62FE",
                            }}
                          >
                            {card.button}
                            <i
                              className="fas fa-arrow-right ms-2"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="d-flex justify-content-center mt-4 indicator-wrapper">
            {(() => {
              const isTabletOrMobile = window.innerWidth < 1200;
              if (!isTabletOrMobile) return null;

              const isTablet = window.innerWidth >= 768;
              const totalIndicators = isTablet
                ? Math.ceil(cardCount / 2)
                : cardCount;

              return (
                <div className="d-flex justify-content-center mt-4">
                  {Array.from({ length: totalIndicators }, (_, i) => (
                    <button
                      key={i}
                      className={`carousel__indicator-3 mx-1 border-0 ${
                        i === activeIndex ? "active" : ""
                      }`}
                      onClick={() => handleIndicatorClick(i)}
                      aria-label={`Go to slide ${i + 1}`}
                      aria-current={i === activeIndex ? "true" : "false"}
                      style={{
                        cursor: "pointer",
                        opacity: isTransitioning ? 0.7 : 1,
                        pointerEvents: isTransitioning ? "none" : "auto",
                      }}
                    />
                  ))}
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProvider;
